export default __webpack_public_path__ + "static/media/contacts-icon-pinpoint.2c320973.svg";